import { Filter, SubZone, User, Zone } from '../../../interfaces'
import { SortField } from '../../../interfaces/DataGrid/DataGridSettings'
import {
  IPickingRoute,
  IPickingRouteSearch
} from '../../../interfaces/PickingRoute/PickingRoute'
import { actionTypes } from '../types/actionTypes'

export const pickingAdminActions = () => {
  const setChangePage = (page: number): actionTypes => ({
    type: 'CHANGE_PAGE',
    payload: page
  })

  const setChangePageSize = (pageSize: number): actionTypes => ({
    type: 'CHANGE_PAGE_SIZE',
    payload: pageSize
  })

  const setTotalItems = (totalItems: number): actionTypes => ({
    type: 'SET_TOTAL_ITEMS',
    payload: totalItems
  })

  const setRows = (rows: IPickingRoute[]): actionTypes => ({
    type: 'SET_ROWS',
    payload: rows
  })

  const setBusqueda = (busqueda: IPickingRouteSearch): actionTypes => ({
    type: 'SET_BUSQUEDA',
    payload: busqueda
  })

  const setFilters = (filters: Filter[]): actionTypes => ({
    type: 'SET_FILTERS',
    payload: filters
  })

  const setIsLoading = (isLoading: boolean): actionTypes => ({
    type: 'SET_IS_LOADING',
    payload: isLoading
  })

  const switchModalConfirmation = (
    switchModalConfirmation: boolean
  ): actionTypes => ({
    type: 'SWITCH_MODAL_ORDER_CONFIRMATION',
    payload: switchModalConfirmation
  })

  const addCheckBoxArray = (checkArray: number[]): actionTypes => ({
    type: 'ADD_CHECKBOX_ARRAY',
    payload: checkArray
  })

  const setMessageStatus = (status: string): actionTypes => ({
    type: 'SET_MESSAGE_STATUS',
    payload: status
  })

  const switchSnackbar = (switchSnack: boolean): actionTypes => ({
    type: 'SWITCH_SNACKBAR',
    payload: switchSnack
  })

  const setMessageColor = (color: string): actionTypes => ({
    type: 'SET_MESSAGE_COLOR',
    payload: color
  })

  const switchModal = (switchModal: boolean): actionTypes => ({
    type: 'SWITCH_MODAL',
    payload: switchModal
  })

  const setIsLoadingConfirm = (isLoadingConfirm: boolean): actionTypes => ({
    type: 'SET_IS_LOADING_CONFIRM',
    payload: isLoadingConfirm
  })

  const setZonesByWarehouse = (zonesByWarehouse: Zone[]): actionTypes => ({
    type: 'SET_ZONES_BY_WAREHOUSE',
    payload: zonesByWarehouse
  })

  const setUsers = (users: User[]): actionTypes => ({
    type: 'SET_USERS',
    payload: users
  })
  const setSubZones = (subZones: SubZone[]): actionTypes => ({
    type: 'SET_SUBZONES',
    payload: subZones
  })

  const setOpenDelete = (openDelete: boolean): actionTypes => ({
    type: 'SET_OPEN_DELETE',
    payload: openDelete
  })

  const setEnabledList = (enabledList: boolean): actionTypes => ({
    type: 'SET_ENABLED_LIST',
    payload: enabledList
  })

  const setSorters = (sorters: SortField[]): actionTypes => ({
    type: 'SET_SORTERS',
    payload: sorters
  })

  const setFirstEffect = (firstEffect: boolean): actionTypes => ({
    type: 'SET_FIRST_EFFECT',
    payload: firstEffect
  })

  const setValues = (values: any): actionTypes => ({
    type: 'SET_VALUES',
    payload: values
  })

  const setPickingRouteWithoutStock = (quantity: number): actionTypes => ({
    type: 'SET_PICKINGROUTES_WITHOUT_STOCK',
    payload: quantity
  })

  return {
    setChangePage,
    setChangePageSize,
    setTotalItems,
    setRows,
    setBusqueda,
    setFilters,
    setIsLoading,
    switchModalConfirmation,
    addCheckBoxArray,
    setMessageStatus,
    switchSnackbar,
    setMessageColor,
    switchModal,
    setIsLoadingConfirm,
    setZonesByWarehouse,
    setUsers,
    setSubZones,
    setOpenDelete,
    setEnabledList,
    setSorters,
    setFirstEffect,
    setValues,
    setPickingRouteWithoutStock
  }
}
